export default __webpack_public_path__ + "static/media/fruit26.58bb9701.jpg";